import React from 'react';
import {
  IconActivity,
  IconAdd,
  IconAddCircle,
  IconAirplane,
  IconApps,
  IconArchive,
  IconArrowLeft,
  IconArrowRight,
  IconBarChart,
  IconBell,
  IconBook,
  IconCalendar,
  IconCamera,
  IconCar,
  IconCart,
  IconClipboard,
  IconClose,
  IconCloudy,
  IconCompass,
  IconComputer,
  IconContract,
  IconDay,
  IconDocument,
  IconDocumentText,
  IconDownload,
  IconEdit,
  IconFile,
  IconFileTray,
  IconGrid,
  IconHammer,
  IconHardwareChip,
  IconHelp,
  IconHelpBuoy,
  IconHouse,
  IconImages,
  IconInbox,
  IconInfo,
  IconLeaf,
  IconLibrary,
  IconList,
  IconLogo,
  IconLogoMono,
  IconLogout,
  IconMail,
  IconMailOpen,
  IconMailUnread,
  IconMap,
  IconMeeting,
  IconMic,
  IconMicrosoft,
  IconPaperclip,
  IconPencil,
  IconPowerBI,
  IconPulse,
  IconRefresh,
  IconSchool,
  IconSearch,
  IconSettings,
  IconStar,
  IconStarSelected,
  IconStatsChart,
  IconSubLevel,
  IconTime,
  IconTrash,
  IconTV,
  IconUpload,
  IconUser,
  IconUsers,
  IconVideocam,
  IconWallet,
  IconWarning,
  IconWifi,
  IconWorkplace,
} from '.';

export const Icon = {
  add: <IconAdd />,
  addCircle: <IconAddCircle />,
  allowances: <IconActivity />,
  airplane: <IconAirplane />,
  apps: <IconApps />,
  archive: <IconArchive />,
  arrowLeft: <IconArrowLeft />,
  arrowRight: <IconArrowRight />,
  bell: <IconBell />,
  book: <IconBook />,
  calendar: <IconCalendar />,
  camera: <IconCamera />,
  car: <IconCar />,
  cart: <IconCart />,
  close: <IconClose />,
  cloudy: <IconCloudy />,
  compass: <IconCompass />,
  computer: <IconComputer />,
  contract: <IconContract />,
  contracts: <IconClipboard />,
  day: <IconDay />,
  document: <IconDocument />,
  documentText: <IconDocumentText />,
  download: <IconDownload />,
  edit: <IconEdit />,
  file: <IconFile />,
  fileTray: <IconFileTray />,
  grid: <IconGrid />,
  hammer: <IconHammer />,
  hardwareChip: <IconHardwareChip />,
  help: <IconHelp />,
  helpBuoy: <IconHelpBuoy />,
  house: <IconHouse />,
  images: <IconImages />,
  inbox: <IconInbox />,
  info: <IconInfo />,
  leaf: <IconLeaf />,
  library: <IconLibrary />,
  list: <IconList />,
  logo: <IconLogo />,
  logoMono: <IconLogoMono />,
  logout: <IconLogout />,
  mail: <IconMail />,
  mailOpen: <IconMailOpen />,
  mailUnread: <IconMailUnread />,
  map: <IconMap />,
  meeting: <IconMeeting />,
  mic: <IconMic />,
  microsoft: <IconMicrosoft />,
  paperclip: <IconPaperclip />,
  pencil: <IconPencil />,
  powerBI: <IconPowerBI />,
  price: <IconBarChart />,
  pulse: <IconPulse />,
  refresh: <IconRefresh />,
  school: <IconSchool />,
  search: <IconSearch />,
  settings: <IconSettings />,
  star: <IconStar />,
  starSelected: <IconStarSelected />,
  statsChart: <IconStatsChart />,
  subLevel: <IconSubLevel />,
  time: <IconTime />,
  trash: <IconTrash />,
  tv: <IconTV />,
  upload: <IconUpload />,
  user: <IconUser />,
  users: <IconUsers />,
  videocam: <IconVideocam />,
  wallet: <IconWallet />,
  warning: <IconWarning />,
  wifi: <IconWifi />,
  workplace: <IconWorkplace />,
};
